/**
 * "Change ranking order" — the session-defaults switch (S-33, migration 891).
 *
 * Says whether a session's ranking order, and its cut line, may change after
 * the run. Set at workflow, cycle, track or session level; the most specific
 * level wins and nothing set means yes (owner ruling 2026-10-14). Stored in
 * session_policies.allow_rank_order_change at the given scope; the server
 * (override_session_rank, set_session_cut_line) reads the same rows.
 */
import { SessionPolicySetting, type SessionPolicyScopeIds, type SessionPolicySettingProps } from './SessionPolicySetting';

export type RankOrderChangeScopeIds = SessionPolicyScopeIds;

export type RankOrderChangeSettingProps = Pick<
  SessionPolicySettingProps<boolean>,
  'scopeKind' | 'scopeId' | 'ids' | 'canEdit' | 'onSaved'
>;

export function RankOrderChangeSetting(props: RankOrderChangeSettingProps) {
  return (
    <SessionPolicySetting<boolean>
      {...props}
      field="allowRankOrderChange"
      label="Change ranking order"
      ariaLabel="Change ranking order after the run"
      choices={[
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
      ]}
      fallback={true}
      describe={(allowed) =>
        allowed
          ? 'After the run, the cut line can still be placed, and people with the "Change ranking order" permission can move an item, with a reason.'
          : 'After the run, the order and the cut line stay as the session left them.'
      }
      testId="rank-order-change-setting"
    />
  );
}
